<!-- d:\项目\搏忆购PC\boyigou_web_new\src\views\shopCenter\components\CenterLeft.vue -->
<template>
    <div class="center-left">
        <el-menu :default-active="defaultActive" class="left-menu" mode="vertical" @select="handleMenuSelect">
            <el-menu-item v-for="menu in menuList" :key="menu.index" :index="menu.index">
                {{ menu.label }}
            </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
export default {
    name: 'CenterLeft',
    props: {
        // 菜单列表，格式：[{index: '组件名', label: '菜单显示文本'}]
        menuList: {
            type: Array,
            required: true
        },
        // 默认激活的菜单
        defaultActive: {
            type: String,
            default: ''
        }
    },
    methods: {
        handleMenuSelect(index) {
            // 发送事件通知父组件切换组件
            this.$emit('menu-select', index);
        }
    }
}
</script>

<style scoped>
.center-left {
    width: 200px;
    height: 100%;
    background-color: #ffffff;
    border-right: 1px solid #e8e8e8;
}

.left-menu {
    height: 100%;
    border-right: none;
}

::v-deep .el-menu-item {
    padding-left: 20px !important;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    color: #333333;
    border-left: 3px solid transparent;
    transition: all 0.3s ease;
}

::v-deep .el-menu-item.is-active {
    color: #286CED;
    background-color: #f0f5ff;
    border-left-color: #286CED;
    font-weight: 500;
}

::v-deep .el-menu-item:hover {
    color: #286CED;
    background-color: #f0f5ff;
}
</style>